import { keyframes } from 'styled-components';

export const LOADER_PHASES = {
  INITIATING: 'INITIATING ...',
  SEARCHING: 'SEARCHING ...',
  PAUSED: 'PAUSED',
  READY_TO_SEARCH: 'READY TO SEARCH',
};

export const animationRotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;
